import { ESTADO_STOCK } from "../common/Constants";

export default {
  basicInfoSchema: {
    logistica: {
      _name: 'Logística',
      reception_date: {
        name: 'Fecha de recepción',
        required: false,
        type: 'date',
        dateTo: {
          until: "TODAY"
        },
        disabled: true,
      },
      antiquity_days: {
        name: 'Días de antigüedad',
        required: false,
        disabled: true,
        type: 'number',
      },
      location_id: {
        name: 'Ubicación',
        required: false,
        type: 'AsyncSelectObj',
        endpoint: "/abms/location",
        disabled: true,
      },
      licensee: {
        name: 'Licenciatario',
        required: false,
        disabled:true,
        type: 'text',
      },
      sale_type_id: {
        name: 'Tipo de venta',
        required: false,
        type: 'AsyncSelectObj',
        endpoint: '/saletypes',
      },
      number_keys: {
        name: 'Número de llave',
        required: false,
        type: 'number',
      },
      vin: {
        name: 'VIN',
        type: 'text',
        required: false,
      },
      origen: {
        name: 'País de Origen',
        type: 'AsyncSelectCountries',
        required: false,
      },
    },
    seguimiento: {
      _name: 'Seguimiento',
      estado: {
        name: 'Estado',
        required: true,
        disabled: true,
        options: [
          {label: ESTADO_STOCK.PRONTO_EN_STOCK, disabled: true},
        ],
        objectOptions: true,
        default: ESTADO_STOCK.PRONTO_EN_STOCK,
        type: 'enum',
      },
      offer_number: {
        name: 'Número de oferta',
        required: false,
        type: 'number',
        disabled: true
      },
      offer_date: {
        name: 'Fecha de oferta',
        required: false,
        type: 'date',
        dateTo: {
          until: "TODAY"
        },
        disabled: true
      },
      bill_date: {
        name: 'Fecha de factura',
        required: false,
        type: 'date',
        dateTo: {
          until: "TODAY"
        }
      },
      bill_amount: {
        name: 'Importe de factura',
        required: false,
        type: 'number',
      },
      observaciones: {
        name: 'Observación',
        required: false,
        type: 'textarea',
      },
    }
  },
}
